import { FC } from "react";
import styles from "./Legend.module.sass";
import cn from "classnames";
import { useAppSelector } from "toolkit/hooks";

export const Legend: FC = () => {
	const { tableMode } = useAppSelector((state) => state.stepSeven);

	return (
		<div data-comment-false={true} className={styles.legend}>
			<span className={styles["legend-title"]}>Легенда:</span>
			<div className={styles["legend-item"]}>
				<div
					className={cn(
						styles["legend-item-sign"],
						styles["legend-item-sign-done"],
						tableMode ? styles["legend-item-sign-variant-table"] : styles["legend-item-sign-variant-group"],
					)}></div>
				<span className={styles["legend-item-txt"]}>Все данные присвоены</span>
			</div>
			<div className={styles["legend-item"]}>
				<div
					className={cn(
						styles["legend-item-sign"],
						styles["legend-item-sign-waiting"],
						tableMode ? styles["legend-item-sign-variant-table"] : styles["legend-item-sign-variant-group"],
					)}></div>
				<span className={styles["legend-item-txt"]}>Ожидается присвоение реестрового номера</span>
			</div>
			<div className={styles["legend-item"]}>
				<div
					className={cn(
						styles["legend-item-sign"],
						styles["legend-item-sign-repeat"],
						tableMode ? styles["legend-item-sign-variant-table"] : styles["legend-item-sign-variant-group"],
					)}></div>
				<span className={styles["legend-item-txt"]}>Повторное категорирование</span>
			</div>
			<div className={styles["legend-item"]}>
				<div
					className={cn(
						styles["legend-item-sign"],
						styles["legend-item-sign-lack"],
						tableMode ? styles["legend-item-sign-variant-table"] : styles["legend-item-sign-variant-group"],
					)}></div>
				<span className={styles["legend-item-txt"]}>Нет письма</span>
			</div>
		</div>
		// полный заголовок Окии
	);
};
